import { render, staticRenderFns } from "./Citasview.vue?vue&type=template&id=ab24d9ba&scoped=true"
import script from "./Citasview.vue?vue&type=script&lang=js"
export * from "./Citasview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab24d9ba",
  null
  
)

export default component.exports